import type { RouteObject } from 'react-router-dom';

import type { AuthInitStatus } from '../context/authInit.types';
import { CheckNeededFillSurveyGuard } from '../guards/CheckNeededFillSurveyGuard';
import { BasicLayout } from '../layouts/BasicLayout';
import { AuthInitError } from '../pages/AuthInitError';
import { AuthPending } from '../pages/AuthPending';
import { Logout } from '../pages/Logout';
import { NotFound } from '../pages/NotFound';
import { RegistrationSurvey } from '../pages/RegistrationSurvey';
import { SomethingWentWrong } from '../pages/SomethingWentWrong';

/**
 * Входные данные для построения дерева маршрутов (состояние Keycloak bootstrap и токена).
 */
export interface SurveyRouteBuildParams {
  /** Этап первичной инициализации Keycloak */
  initStatus: AuthInitStatus;
  /** Ошибка init при `initStatus === 'error'` */
  initError: Error | null;
  /** Access token: строка при активной сессии, иначе не показываем авторизованную зону */
  kToken: string | null | boolean;
}

/**
 * Строит `RouteObject[]` для data router: фазы pending/error/login gate или вложенные маршруты с `BasicLayout`.
 *
 * @param params — статус init и токен
 * @returns {RouteObject[]} корневой массив маршрутов для `createBrowserRouter`
 */
export function buildSurveyRouteObjects(params: SurveyRouteBuildParams): RouteObject[] {
  if (params.initStatus === 'pending') {
    return [{ path: '*', element: <AuthPending /> }];
  }

  if (params.initStatus === 'error') {
    return [{ path: '*', element: <AuthInitError error={params.initError} /> }];
  }

  if (typeof params.kToken !== 'string') {
    // kToken не получен: после `check-sso` hook сам запустит интерактивный логин,
    // поэтому показываем обычный экран ожидания.
    return [{ path: '*', element: <AuthPending /> }];
  }

  return [
    {
      path: '/',
      element: <BasicLayout />,
      children: [
        { path: 'logout', element: <Logout /> },
        {
          element: <CheckNeededFillSurveyGuard />,
          children: [
            { index: true, element: <AuthPending /> },
            { path: 'registration-survey', element: <RegistrationSurvey /> },
            { path: 'error', element: <SomethingWentWrong /> },
            { path: '*', element: <NotFound /> },
          ],
        },
      ],
    },
  ];
}
